import { NavLink, Navigate, Route, Routes } from 'react-router'
import { useBusiness } from './Layout'
import { VenueSection, PolicySection, FeaturesSection } from './settings/Venue'
import { HoursSection } from './settings/Hours'
import { AreasSection } from './settings/Areas'
import { WebsiteSection } from './settings/Website'
import { TeamSection } from './settings/Team'
import { AuditSection } from './settings/Audit'

export function SettingsPage() {
  const { can, business } = useBusiness()
  // Absolute links: inside a splat route, relative links would resolve against the splat part.
  const base = `/b/${business.id}/settings`
  const tabs = [
    { to: 'venue', label: 'Venue' },
    { to: 'hours', label: 'Hours' },
    { to: 'areas', label: 'Areas' },
    { to: 'policy', label: 'Booking rules' },
    { to: 'website', label: 'Website' },
    ...(can('owner') ? [{ to: 'team', label: 'Team' }, { to: 'audit', label: 'Activity' }] : []),
  ]
  return (
    <>
      <div className="topbar">
        <h1>Settings</h1>
      </div>
      <nav className="tabs" aria-label="Settings sections">
        {tabs.map((t) => (
          <NavLink key={t.to} to={`${base}/${t.to}`} className={({ isActive }) => (isActive ? 'active' : '')}>
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Routes>
        <Route index element={<Navigate to={`${base}/venue`} replace />} />
        <Route path="venue" element={<VenueSection />} />
        <Route path="hours" element={<HoursSection />} />
        <Route path="areas" element={<AreasSection />} />
        <Route
          path="policy"
          element={
            <div className="stack-lg">
              <PolicySection />
              <FeaturesSection />
            </div>
          }
        />
        <Route path="website" element={<WebsiteSection />} />
        <Route path="team" element={<TeamSection />} />
        <Route path="audit" element={<AuditSection />} />
        <Route path="*" element={<Navigate to={`${base}/venue`} replace />} />
      </Routes>
    </>
  )
}
